import { useMultiStyleConfig, PopoverAnchor, Box } from '@chakra-ui/react';
import { useTranslation } from '@vygruppen/spor-i18n-react';
import { CalendarOutline24Icon } from '@vygruppen/spor-icon-react';
import React, { useRef } from 'react';
import { useButton } from 'react-aria';

// src/CalendarTriggerButton.tsx
var CalendarTriggerButton = (props) => {
  const { t } = useTranslation();
  const styles = useMultiStyleConfig("Datepicker", {});
  const ref = useRef(null);
  const { buttonProps } = useButton(props, ref);
  return /* @__PURE__ */ React.createElement(PopoverAnchor, null, /* @__PURE__ */ React.createElement(Box, {
    ref,
    as: "button",
    type: "button",
    "aria-label": t(texts.openCalendar),
    sx: styles.calendarTriggerButton,
    ...buttonProps
  }, /* @__PURE__ */ React.createElement(CalendarOutline24Icon, null)));
};
var texts = {
  openCalendar: {
    nb: "\xC5pne kalender",
    sv: "\xD6ppna kalender",
    en: "Open calendar"
  }
};

export { CalendarTriggerButton };
